import type { UserProfileJSONObject } from '@ikegps/core-api';
import { ColorHash } from '@ikegps/core-shared';
import type { MithrilVNode } from '../../mithril';
import { m } from '../../services/render.service';
import { userDisplayInitials, userDisplayName } from '../../util/userDisplayName';
import { addStyles, DefaultTheme } from '../theme';

export const CSS = {
	container: 'c-UserIcon',
	unknown: 'c-UserIcon--Unknown',
};

addStyles({
	[CSS.container]: {
		width: DefaultTheme.space(8),
		height: DefaultTheme.space(8),
		'min-width': DefaultTheme.space(8),
		'max-height': DefaultTheme.space(8),
		'border-radius': '50%',
		color: DefaultTheme.font.color.white,
		'font-weight': DefaultTheme.font.weight.bold,
		display: 'flex',
		'justify-content': 'center',
		'align-items': 'center',
	},
	[CSS.unknown]: {
		'background-color': DefaultTheme.font.color.divider,
	},
});

export const UserIcon = {
	view(user: UserProfileJSONObject): MithrilVNode {
		if (user == null) {
			return m('div', { className: `${CSS.container} ${CSS.unknown}` });
		}

		const color = ColorHash.hash(user.objectId);

		return m(
			'div',
			{
				className: CSS.container,
				title: userDisplayName(user),
				style: {
					'background-color': color,
				},
			},
			userDisplayInitials(user)
		);
	},
};
